export default "__VITE_ASSET__DlQE5xx5__"